<template>
  <v-container>
    <div id="grid-productos">
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
      <v-toolbar card color="white">
        <v-toolbar-title class="indigo--text"
          >Listado de Excepciones</v-toolbar-title
        >
      </v-toolbar>

      <v-toolbar card color="white">
        <v-flex lg12>
          <p>
            <span class="font-weight-bold">Nivel:</span>
            {{ nivel }}
          </p>
          <p>
            <span class="font-weight-bold">Etapa Proceso:</span>
            {{ etapaProceso }}
          </p>
        </v-flex>
      </v-toolbar>

      <v-layout justify-center>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <v-spacer></v-spacer>
          <v-data-table
            :headers="headers"
            :items="itemsExcepciones"
            :rows-per-page-items="rowsTable"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.nivel.codNivelAce }}</td>
              <td class="text-xs-left">{{ props.item.etapaProceso }}</td>
              <td class="text-xs-left">{{ props.item.fechaExcepcion }}</td>
              <td class="text-xs-left">{{ props.item.pallet }}</td>
              <td class="text-xs-left">{{ props.item.codigoCurso }}</td>
              <td class="text-xs-left">{{ props.item.tipoDocumento }}</td>
              <td class="text-xs-left">{{ props.item.tipoExcepcion }}</td>
              <td class="text-xs-left">{{ props.item.observacion }}</td>
              <td class="text-xs-left">{{ props.item.fechaReporte }}</td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </div>
  </v-container>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";

export default {
  name: "grid-reportes",

  components: {
    Loading,
  },
  props: {
    rowsTable: String,
    tipeView: String,
  },

  data() {
    return {
      loading: false,
      usuarioLoggedTipe: "",
      rowsPerPageItems: [30],
      pagination: {
        rowsPerPage: 30,
      },
      idContrato: "",
      headers: [
        { text: "Nivel", align: "left", sortable: false, value: "nivel" },
        {
          text: "Etapa Proceso",
          align: "left",
          sortable: false,
          value: "etapaProceso",
        },
        {
          text: "Fecha Excepción",
          align: "left",
          sortable: false,
          value: "fechaExcepcion",
        },
        { text: "Pallet", align: "left", sortable: false, value: "pallet" },
        {
          text: "Código Curso",
          align: "left",
          sortable: false,
          value: "codigoCurso",
        },
        {
          text: "Tipo Documento",
          align: "left",
          sortable: false,
          value: "tipoDocumento",
        },
        {
          text: "Tipo Excepción",
          align: "left",
          sortable: false,
          value: "tipoExcepcion",
        },
        {
          text: "Observación",
          align: "left",
          sortable: false,
          value: "observacion",
        },
        {
          text: "Fecha Reporte",
          align: "left",
          sortable: false,
          value: "fechaReporte",
        },
      ],
      itemsExcepciones: [],
      proceso: "",
    };
  },
  created() {
    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.nivel = this.$route.params.nivel;
    this.idNivel = this.$route.params.idNivel;
    this.etapaProceso = this.$route.params.etapaProceso;

    this.loadData(this.idNivel, this.etapaProceso);
  },

  mounted() {},
  methods: {
    async loadExcepciones(idNivel, etapaProceso) {
      this.body = {
        idContrato: this.idContrato,
        proceso: this.proceso,
        idNivel: idNivel,
        etapaProceso: etapaProceso,
      };
      return await axios
        .post("/excepcionesCaptura/getExcepciones", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
          return [];
        });
    },
    async loadData(idNivel, etapaProceso) {
      this.loading = true;
      this.itemsExcepciones = await this.loadExcepciones(idNivel, etapaProceso);
      if (this.itemsExcepciones.length > 0) {
        this.alerta = false;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },
    reload() {
      setTimeout(() => {
        this.$parent.reloadDocumento();
      }, 1000);
    },
    volver() {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "ProcesoCaptura",
          params: { tipeView: "consulta" },
        });
      }, 1000);
    },
  },
};
</script>
